import { AudienceTypeEnum } from '../enums/audience-type.enum';
import { IAudienceResourceQuery } from '../interfaces/audience.query.interface';

// @dynamic
export class AudienceResource {
    id: string;
    name: string;
    type: number;
    isAutoGenerated: boolean;
    childrenCount: number;
    isSelected?: boolean;
    isAlreadyLinkedAudience?: boolean;
    parent: {
        id: string;
        name: string;
        type: number;
        isAutoGenerated: boolean;
    };
    children: any[];

    constructor(audienceQuery?: IAudienceResourceQuery) {
        if (audienceQuery) {
            this.id = audienceQuery.id.toString();
            this.name = audienceQuery.name;
            this.type = audienceQuery.type;
            this.isAutoGenerated = audienceQuery.is_auto_generated;
            this.childrenCount = audienceQuery.children_count;

            if (audienceQuery.parent) {
                this.parent = {
                    id: audienceQuery.parent.id.toString(),
                    name: audienceQuery.parent.name,
                    type: audienceQuery.type,
                    isAutoGenerated: audienceQuery.parent.is_auto_generated,
                };
            } else {
                this.parent = null;
            }
            this.children = [];
        }
    }
}
